import { render, staticRenderFns } from "./qlc.vue?vue&type=template&id=3b53805e"
import script from "./qlc.vue?vue&type=script&lang=js"
export * from "./qlc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports